export const MBType = [
  {
    label: '新築マンション（1部屋）',
    value: 1001,
  },
  {
    label: '新築マンション（分譲）',
    value: 1011,
  },
  {
    label: '中古マンション（1部屋）',
    value: 1021,
  },
  {
    label: '新築タウンハウス（1部屋）',
    value: 1002,
  },
  {
    label: '新築タウンハウス（分譲）',
    value: 1012,
  },
  {
    label: '中古タウンハウス（1部屋）',
    value: 1022,
  },
  {
    label: '新築戸建て（1戸）',
    value: 1101,
  },
  {
    label: '新築戸建て（分譲）',
    value: 1111,
  },
  {
    label: '中古戸建（1戸）',
    value: 1121,
  },
  {
    label: '新築テラスハウス（1戸）',
    value: 1102,
  },
  {
    label: '新築テラスハウス（分譲）',
    value: 1112,
  },
  {
    label: '中古テラスハウス（1戸）',
    value: 1122,
  },
  {
    label: '売地',
    value: 1201,
  },
  {
    label: '借地権',
    value: 1202,
  },
  {
    label: '底地権',
    value: 1203,
  },
  {
    label: '店舗',
    value: 2101,
  },
  {
    label: '店舗付住宅',
    value: 2102,
  },
  {
    label: '賃貸併用住宅',
    value: 2103,
  },
  {
    label: '事務所',
    value: 2104,
  },
  {
    label: '店舗事務所',
    value: 2105,
  },
  {
    label: 'ビル',
    value: 2106,
  },
  {
    label: 'マンション',
    value: 2107,
  },
  {
    label: 'アパート',
    value: 2108,
  },
  {
    label: '戸建賃貸',
    value: 2109,
  },
  {
    label: '倉庫',
    value: 2110,
  },
  {
    label: '工場',
    value: 2111,
  },
  {
    label: 'ホテル',
    value: 2112,
  },
  {
    label: '別荘・保養所',
    value: 2113,
  },
  {
    label: 'その他',
    value: 2199,
  },
  {
    label: '店舗',
    value: 2001,
  },
  {
    label: '事務所',
    value: 2002,
  },
  {
    label: '店舗事務所',
    value: 2003,
  },
  {
    label: 'マンション',
    value: 2004,
  },
  {
    label: 'リゾートマンション',
    value: 2005,
  },
  {
    label: 'その他',
    value: 2099,
  },
  {
    label: '駐車場',
    value: 2201,
  },
  {
    label: '土地',
    value: 2202,
  },
  {
    label: '別荘地・土地',
    value: 2203,
  },
  {
    label: '軍用地',
    value: 2301,
  },
]
// 居住用
const Residence = [1001, 1011, 1021, 1002, 1012, 1022, 1101, 1111, 1121, 1102, 1112, 1122, 1201, 1202, 1203]
// 事業・投資用
const Investment = [
  2101,
  2102,
  2103,
  2104,
  2105,
  2106,
  2107,
  2108,
  2109,
  2110,
  2111,
  2112,
  2113,
  2199,
  2001,
  2002,
  2003,
  2004,
  2005,
  2099,
  2201,
  2202,
  2203,
  2301,
]

// マンション
const Mansion = [1001, 1002, 1011, 1012, 1021, 1022]
// マンション 新築1部屋
const NewOneRoomMansion = [1001, 1002]
// マンション 新築分譲
const NewLotsMansion = [1011, 1012]
// マンション 中古
const UsedMansion = [1021, 1022]

// 戸建て
const House = [1101, 1102, 1111, 1112, 1121, 1122]
// 戸建て 新築1部屋
const NewOneRoomHouse = [1101, 1102]
// 戸建て 新築分譲
const NewLotsHouse = [1111, 1112]
// 戸建て 中古
const UsedHouse = [1121, 1122]

// 土地
const Land = [1201, 1202, 1203]
// 土地 売地
const LandSale = [1201]
// 土地 借地
const LandLease = [1202]
// 土地 低地
const LandInterest = [1203]

// 建物全部（上物有）
const WholeBuilding = [2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108, 2109, 2110, 2111, 2112, 2113, 2199]
// 建物全部（上物無）
const WholeLand = [2201, 2202, 2203]
// 建物一部（区分所有）
const PartBuilding = [2001, 2002, 2003, 2004, 2005, 2099]
// 軍用地
const Military = [2301]
// 新築
const NewBuilding = [1001, 1002, 1101, 1102]

// 住居判定
export function isResidence(type) {
  return Residence.includes(type) ? true : false
}

export function isInvestment(type) {
  return Investment.includes(type) ? true : false
}
// マンション判定
export function isMansion(type) {
  return Mansion.includes(type) ? true : false
}
// マンション 新築1部屋 判定
export function isNewOneRoomMansion(type) {
  return NewOneRoomMansion.includes(type) ? true : false
}
// マンション 新築分譲 判定
export function isNewLotsMansion(type) {
  return NewLotsMansion.includes(type) ? true : false
}
// マンション 中古 判定
export function isUsedMansion(type) {
  return UsedMansion.includes(type) ? true : false
}
// 戸建て判定
export function isHouse(type) {
  return House.includes(type) ? true : false
}
// 戸建て 新築1部屋 判定
export function isNewOneRoomHouse(type) {
  return NewOneRoomHouse.includes(type) ? true : false
}
// 戸建て 新築分譲 判定
export function isNewLotsHouse(type) {
  return NewLotsHouse.includes(type) ? true : false
}
// 戸建て 中古 判定
export function isUsedHouse(type) {
  return UsedHouse.includes(type) ? true : false
}
// 土地判定
export function isLand(type) {
  return Land.includes(type) ? true : false
}
// 土地 売地 判定
export function isLandSale(type) {
  return LandSale.includes(type) ? true : false
}
// 土地 借地 判定
export function isLandLease(type) {
  return LandLease.includes(type) ? true : false
}
// 土地 低地 判定
export function isLandInterest(type) {
  return LandInterest.includes(type) ? true : false
}
// 建物全部（上物有） 判定
export function isWholeBuilding(type) {
  return WholeBuilding.includes(type) ? true : false
}
// 建物全部（上物無） 判定
export function isWholeLand(type) {
  return WholeLand.includes(type) ? true : false
}
// 建物一部（区分所有） 判定
export function isPartBuilding(type) {
  return PartBuilding.includes(type) ? true : false
}
// 軍用地 判定
export function isMilitary(type) {
  return Military.includes(type) ? true : false
}
// 1戸・1部屋 判定
export function isSingle(type) {
  return [1001, 1021, 1002, 1022, 1101, 1121, 1102, 1122].includes(type) ? true : false
}
// 新築 判定
export function isNewBuilding(type) {
  return NewBuilding.includes(type) ? true : false
}
// 物件種別 居住用 リスト
export function residenceList() {
  return _.filter(MBType, function(item) {
    return _.includes(Residence, item.value)
  })
}
// 物件種別 建物全部 リスト
export function wholeList() {
  const Whole = _.concat(WholeBuilding, WholeLand, Military)
  const wholeList = _.filter(MBType, function(item) {
    return _.includes(Whole, item.value)
  })
  // 詳細検索表示用にその他を後ろに配置する
  const categoryEtc = _.remove(wholeList, function(item) {
    return item.value === 2199
  })
  wholeList.push(categoryEtc[0])
  return wholeList
}
// 物件種別 建物一部 リスト
export function partBuildingList() {
  return _.filter(MBType, function(item) {
    return _.includes(PartBuilding, item.value)
  })
}
